export const companies = [
  {
    id: 1,
    name: '株式会社BEEM',
    industry: '飲食',
    tiktokVideoId: '6980628952943578370',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/89abee5924554205ba41317f3ea52fa1_1625304338~tplv-tiktokx-origin.image?dr=14575&x-expires=1773849600&x-signature=yHWYqsZjIxIp7%2B%2B6QEkq2U%2FqV6I%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '未経験から3ヶ月で店長に。成長スピードがすごい',
    tags: ['#未経験OK', '#説明会あり', '#即日勤務可'],
    publishedDays: 2,
    hasLiveToday: true,
    liveSchedule: '今夜20:00〜',
    description:
      '都内で急成長中のカジュアルダイニング。若手が活躍できる環境で、未経験でもしっかりサポート。',
    upcomingSessions: [
      { date: '今夜', time: '20:00〜21:00', platform: 'TikTok LIVE' },
      { date: '今週金曜', time: '19:00〜20:00', platform: 'YouTube LIVE' }
    ]
  },
  {
    id: 2,
    name: '自由なタクシー会社',
    industry: '交通',
    tiktokVideoId: '7487872602728320274',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/o4ckRfCrIEXCmuKBkRnEqDHB6InAUOOfgArFXR~tplv-tiktokx-origin.image?dr=14575&x-expires=1773849600&x-signature=uH4T6Mg7Fd20RYmhiILQPD%2BNeII%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: 'ドライバーじゃない物流の仕事。意外と知られてない',
    tags: ['#第二新卒歓迎', '#説明会あり'],
    publishedDays: 1,
    hasLiveToday: false,
    liveSchedule: '今週木曜19:00〜',
    description:
      '最新テクノロジーを活用した物流センター。体力勝負だけじゃない、これからの物流を体験できます。',
    upcomingSessions: [
      { date: '今週木曜', time: '19:00〜20:00', platform: 'YouTube LIVE' },
      { date: '来週火曜', time: '20:00〜21:00', platform: 'TikTok LIVE' }
    ]
  },
  {
    id: 3,
    name: 'バイトな日常',
    industry: '小売',
    tiktokVideoId: '7469322600087358728',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/o0oaElAOiAcuhD46BY0XZpXiIBEBVnK3PVINE~tplv-tiktokx-origin.image?dr=14575&x-expires=1773849600&x-signature=zYyoLjqXjlfS6nGQJQx9XeKtaf8%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: 'SNS運用も任される。好きを仕事にできる環境',
    tags: ['#未経験OK', '#SNS運用'],
    publishedDays: 3,
    hasLiveToday: false,
    liveSchedule: '来週月曜18:00〜',
    description:
      'トレンドを発信するアパレルショップ。接客だけでなく、SNSでの情報発信も担当できます。',
    upcomingSessions: [
      { date: '来週月曜', time: '18:00〜19:00', platform: 'TikTok LIVE' }
    ]
  },
  {
    id: 4,
    name: '株式会社利根川産業',
    industry: '製造',
    tiktokVideoId: '7445879647339875602',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/owfnUoVZCWDVMVsE7FF7cIdBBQLCIgBeQ3BUNA~tplv-tiktokx-origin.image?dr=14575&x-expires=1773849600&x-signature=60Tu6ZNedVE%2BFsmFsM1f6dje%2BB8%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '工場のイメージ変わる。最新設備でスマートに働く',
    tags: ['#未経験OK', '#説明会あり', '#寮完備'],
    publishedDays: 1,
    hasLiveToday: true,
    liveSchedule: '今夜21:00〜',
    description:
      '最先端の製造現場。クリーンで快適な環境で、未来のものづくりに携われます。',
    upcomingSessions: [
      { date: '今夜', time: '21:00〜22:00', platform: 'YouTube LIVE' },
      { date: '今週土曜', time: '14:00〜15:00', platform: 'TikTok LIVE' }
    ]
  },
  {
    id: 5,
    name: '大洋フェリー',
    industry: '交通',
    tiktokVideoId: '7386614372191177985',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/4433e4a13aa447bfaae478fca0ff434d_1719830194~tplv-tiktokx-origin.image?dr=14575&x-expires=1773849600&x-signature=IBlL%2F78Fmxlo7XD52iFTJE1eMbU%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: 'フェリーで働く。海の仕事の魅力を発信中',
    tags: ['#未経験OK', '#朝活'],
    publishedDays: 4,
    hasLiveToday: false,
    liveSchedule: '今週金曜17:00〜',
    description:
      '大洋フェリーは海上輸送のプロ集団。海の仕事の魅力を体験できます。',
    upcomingSessions: [
      { date: '今週金曜', time: '17:00〜18:00', platform: 'YouTube LIVE' }
    ]
  },
  {
    id: 7,
    name: 'Owen株式会社',
    industry: '飲食',
    tiktokVideoId: '7415571652102098192',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/okJIhByjzhA9pglqA1iiwEBKBtAK1lTII9fSoR~tplv-tiktokx-origin.image?dr=14575&x-expires=1773849600&x-signature=jHK%2FW9efeLH2rT%2F0k7Ig9m1ZZBs%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '夜の飲食業界、デリバリーで新しいカタチ',
    tags: ['#未経験OK', '#説明会あり', '#シフト自由'],
    publishedDays: 2,
    hasLiveToday: true,
    liveSchedule: '今夜19:30〜',
    description:
      'デリバリー特化型のパブスタイル飲食店。夜の時間帯に活躍できる、新しい飲食のカタチ。',
    upcomingSessions: [
      { date: '今夜', time: '19:30〜20:30', platform: 'TikTok LIVE' },
      { date: '来週水曜', time: '19:00〜20:00', platform: 'YouTube LIVE' }
    ]
  },
  {
    id: 8,
    name: '設備屋の親方',
    industry: '建設',
    tiktokVideoId: '7367278140076363024',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/39ce5860ac464c6bb266850d122461cd_1715328121~tplv-tiktokx-origin.image?dr=14575&x-expires=1773849600&x-signature=3AgtCgO110XlDHWeR4MWkKH1B78%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '職人の世界へ。設備工事の面白さを発信中',
    tags: ['#未経験OK', '#説明会あり', '#資格取得支援'],
    publishedDays: 1,
    hasLiveToday: true,
    liveSchedule: '今夜20:30〜',
    description:
      '設備工事のプロ集団。未経験から一人前の職人を目指せる環境が整っています。',
    upcomingSessions: [
      { date: '今夜', time: '20:30〜21:30', platform: 'YouTube LIVE' },
      { date: '今週日曜', time: '15:00〜16:00', platform: 'TikTok LIVE' }
    ]
  },
  {
    id: 9,
    name: 'VES株式会社',
    industry: '建設',
    tiktokVideoId: '7543165464290020626',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/oMvo0i1IBAAuiNA59wEQuaYty1BKI3vVGBC6q~tplv-tiktokx-origin.image?dr=14575&x-expires=1773849600&x-signature=SoYKGVvwKp1vwB07hZDJj02TZdE%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '建設・設備のプロ集団。現場のリアルを発信',
    tags: ['#未経験OK', '#説明会あり', '#資格取得支援'],
    publishedDays: 1,
    hasLiveToday: true,
    liveSchedule: '今夜22:00〜',
    description:
      'VES株式会社は建設・設備工事のプロ集団。技術を学んで、将来のキャリアを築けます。',
    upcomingSessions: [
      { date: '今夜', time: '22:00〜23:00', platform: 'TikTok LIVE' },
      { date: '今週日曜', time: '16:00〜17:00', platform: 'YouTube LIVE' }
    ]
  },
  {
    id: 10,
    name: '株式会社シンギュラリティ',
    industry: 'IT',
    tiktokVideoId: '7555893378819411208',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/oQQBIeFgcHo8dpbbDBDAIzt5jnRA7CTIweEUf9~tplv-tiktokx-origin.image?dr=14575&x-expires=1773849600&x-signature=cRtZ1mqtdOrFJclqpZIfGH08xLQ%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: 'IT×採用の新しいカタチ。テクノロジーで仕事を変える',
    tags: ['#未経験OK', '#説明会あり', '#成長できる'],
    publishedDays: 1,
    hasLiveToday: true,
    liveSchedule: '今夜18:00〜',
    description:
      '株式会社シンギュラリティはITと採用を掛け合わせた新しい会社。テクノロジーで仕事の未来を変えます。',
    upcomingSessions: [
      { date: '今夜', time: '18:00〜19:00', platform: 'YouTube LIVE' },
      { date: '今週土曜', time: '10:00〜11:00', platform: 'TikTok LIVE' }
    ]
  },
  {
    id: 11,
    name: 'パーツ製造 SEIMITSU',
    industry: '製造',
    tiktokVideoId: '7437234644878571794',
    videoThumbnail:
      'https://public.readdy.ai/ai/img_res/90e67d9d73304e2ac565d85c2dae0982.jpg',
    editorNote: '精密部品づくり。ものづくりの原点がここに',
    tags: ['#未経験OK', '#技術習得'],
    publishedDays: 4,
    hasLiveToday: false,
    liveSchedule: '来週火曜19:00〜',
    description:
      '高精度な部品製造。丁寧な研修で、確かな技術が身につきます。',
    upcomingSessions: [
      { date: '来週火曜', time: '19:00〜20:00', platform: 'YouTube LIVE' }
    ]
  },
  {
    id: 13,
    name: 'ドラッグストア GENKI',
    industry: '小売',
    tiktokVideoId: '7448051028252730641',
    videoThumbnail:
      'https://readdy.ai/api/search-image?query=modern%20drugstore%20pharmacy%20staff%20helping%20customer%20bright%20clean%20store%20vertical%20format%20simple%20background%20young%20professional%20worker%20contemporary%20minimalist%20design%20natural%20lighting%20organized%20shelves&width=400&height=700&seq=thumb13&orientation=portrait',
    editorNote: '登録販売者の資格も取れる。キャリアアップ支援',
    tags: ['#未経験OK', '#資格取得支援'],
    publishedDays: 3,
    hasLiveToday: false,
    liveSchedule: '今週土曜11:00〜',
    description:
      '地域の健康を支えるドラッグストア。資格取得のサポートも充実。',
    upcomingSessions: [
      { date: '今週土曜', time: '11:00〜12:00', platform: 'YouTube LIVE' }
    ]
  },
  {
    id: 15,
    name: '食品工場 OISHII',
    industry: '製造',
    tiktokVideoId: '7441553890706098449',
    videoThumbnail:
      'https://readdy.ai/api/search-image?query=food%20manufacturing%20factory%20worker%20in%20clean%20room%20modern%20hygienic%20facility%20vertical%20format%20simple%20background%20young%20professional%20staff%20contemporary%20minimalist%20design%20bright%20organized%20clean%20environment&width=400&height=700&seq=thumb15&orientation=portrait',
    editorNote: '食の安全を守る。清潔な環境で働ける',
    tags: ['#未経験OK', '#説明会あり', '#衛生管理'],
    publishedDays: 1,
    hasLiveToday: false,
    liveSchedule: '今夜18:00〜',
    description:
      '衛生管理が徹底された食品工場。安心・安全な食品づくりに携われます。',
    upcomingSessions: [
      { date: '今夜', time: '18:00〜19:00', platform: 'YouTube LIVE' },
      { date: '今週土曜', time: '10:00〜11:00', platform: 'TikTok LIVE' }
    ]
  },
  // ── 今週の注目 ──────────────────────────────
  {
    id: 16,
    name: '三和交通',
    industry: '交通',
    tiktokVideoId: '7392896402726079751',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/6c21027c049542728be9ad6c0f416e5d_1721292834~tplv-tiktokx-origin.image?dr=14575&x-expires=1773846000&x-signature=BU4YFUIL5sB%2BTCcShO32eIsf%2FIg%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: 'タクシー会社のリアルな日常。意外と楽しそう！',
    tags: ['#未経験OK', '#説明会あり', '#二種免許取得支援'],
    publishedDays: 2,
    hasLiveToday: false,
    liveSchedule: '今週土曜19:00〜',
    description:
      '三和交通は首都圏で活躍するタクシー会社。未経験から二種免許取得まで全力サポート。',
    upcomingSessions: [
      { date: '今週土曜', time: '19:00〜20:00', platform: 'TikTok LIVE' }
    ]
  },
  {
    id: 17,
    name: '踊る上司（ほしら0309）',
    industry: 'オフィス',
    tiktokVideoId: '7556763959739600136',
    videoThumbnail:
      'https://p77-sign-sg.tiktokcdn.com/tos-alisg-p-0037/ok1SQcIFtDANBsubkwFkBRoCOEPgtBZ3Qqf5fE~tplv-tiktokx-origin.image?dr=14575&x-expires=1773846000&x-signature=iSR216SdXYFKEeofXH0cy689wbU%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '踊る上司がいる会社。職場の雰囲気が最高すぎる',
    tags: ['#職場環境◎', '#未経験OK', '#チームワーク'],
    publishedDays: 1,
    hasLiveToday: false,
    liveSchedule: '今週水曜20:00〜',
    description:
      'ノリのいい上司と一緒に働ける職場。明るい雰囲気で毎日楽しく仕事できます。',
    upcomingSessions: [
      { date: '今週水曜', time: '20:00〜21:00', platform: 'TikTok LIVE' }
    ]
  },
  {
    id: 18,
    name: 'バ先の女子4人',
    industry: '小売',
    tiktokVideoId: '7568459278416121096',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/o4QSWR8IlC3CfAjVVkgAKLIDIeGl8SSIJeslm4~tplv-tiktokx-origin.image?dr=14575&x-expires=1773846000&x-signature=MCKklk6Vd3cTdWuLTisWsuOoI7E%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my2',
    editorNote: 'バイト仲間と踊ってみた。職場の仲良さが伝わる',
    tags: ['#バイト歓迎', '#シフト自由', '#仲間できる'],
    publishedDays: 3,
    hasLiveToday: false,
    liveSchedule: '来週月曜18:00〜',
    description:
      '仲間と楽しく働けるお店。シフトも自由で、学生さんも大歓迎です。',
    upcomingSessions: [
      { date: '来週月曜', time: '18:00〜19:00', platform: 'TikTok LIVE' }
    ]
  },
  {
    id: 19,
    name: '警備会社MSK',
    industry: '警備',
    tiktokVideoId: '7205140335473724674',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/543778aeee4743c2b2bf9c9bbdedb12e_1677577472~tplv-tiktokx-origin.image?dr=14575&x-expires=1773846000&x-signature=uQc%2FRhaNKXdD3gnpo6h%2FGLWVk2U%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '警備の仕事ってこんな感じ。意外とやりがいある',
    tags: ['#未経験OK', '#資格取得支援', '#安定収入'],
    publishedDays: 2,
    hasLiveToday: false,
    liveSchedule: '今週金曜20:00〜',
    description:
      '警備のプロ集団MSK。未経験から資格取得まで丁寧にサポートします。',
    upcomingSessions: [
      { date: '今週金曜', time: '20:00〜21:00', platform: 'YouTube LIVE' }
    ]
  },
  {
    id: 20,
    name: '株式会社FULLBASE',
    industry: '不動産',
    tiktokVideoId: '7609641220821765397',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/os4zdiCEiIqIgrmotaffAJSARvKzpBUsBBmGBz~tplv-tiktokx-origin.image?dr=14575&x-expires=1773846000&x-signature=dJEWl6ZuTB7gYjhefoWpAqbn1Vw%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '不動産の仕事、こんなに楽しいの知らなかった',
    tags: ['#未経験OK', '#インセンティブあり', '#成長できる'],
    publishedDays: 1,
    hasLiveToday: false,
    liveSchedule: '今週木曜19:00〜',
    description:
      '急成長中の不動産会社FULLBASE。頑張りがしっかり収入に反映される環境です。',
    upcomingSessions: [
      { date: '今週木曜', time: '19:00〜20:00', platform: 'TikTok LIVE' }
    ]
  },
  // ── 今夜・今週の説明会 ──────────────────────
  {
    id: 21,
    name: '限界集客スタンドネキ',
    industry: 'サービス',
    tiktokVideoId: '7543930257724755207',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/543778aeee4743c2b2bf9c9bbdedb12e_1677577472~tplv-tiktokx-origin.image?dr=14575&x-expires=1773846000&x-signature=uQc%2FRhaNKXdD3gnpo6h%2FGLWVk2U%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: 'ガソリンスタンドの集客がすごい。元気もらえる',
    tags: ['#未経験OK', '#元気な職場', '#シフト自由'],
    publishedDays: 1,
    hasLiveToday: true,
    liveSchedule: '今夜20:00〜',
    description:
      '元気いっぱいのガソリンスタンド。明るい職場でお客様に喜ばれる仕事です。',
    upcomingSessions: [
      { date: '今夜', time: '20:00〜21:00', platform: 'TikTok LIVE' },
      { date: '今週日曜', time: '15:00〜16:00', platform: 'YouTube LIVE' }
    ]
  },
  {
    id: 22,
    name: 'やまピーとバッシー',
    industry: 'オフィス',
    tiktokVideoId: '7244479042399833362',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/621bce80f1f44382bf22056142470b4c_1686736733~tplv-tiktokx-origin.image?dr=14575&x-expires=1773846000&x-signature=8pFm85pIjsgoRjG%2BZVeB4mUAZdI%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: 'やまピーとバッシーのコンビが最高。職場が楽しそう',
    tags: ['#職場環境◎', '#未経験OK', '#チームワーク'],
    publishedDays: 2,
    hasLiveToday: true,
    liveSchedule: '今夜21:00〜',
    description:
      '個性豊かなメンバーが活躍するオフィス。楽しく働きながら成長できます。',
    upcomingSessions: [
      { date: '今夜', time: '21:00〜22:00', platform: 'TikTok LIVE' },
      { date: '今週土曜', time: '14:00〜15:00', platform: 'YouTube LIVE' }
    ]
  },
  // ── 人手不足業界特集 ────────────────────────
  {
    id: 23,
    name: '手原産業倉庫',
    industry: '物流',
    tiktokVideoId: '7294576240298708232',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/66ea9fd6c42940e69c75616f4b667cb8_1698400887~tplv-tiktokx-origin.image?dr=14575&x-expires=1773846000&x-signature=fbzYmd0SyClEAZyWQHe0cOu21Kg%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '倉庫の仕事ってこんな感じ。チームワークが大事',
    tags: ['#未経験OK', '#チームワーク', '#安定収入'],
    publishedDays: 3,
    hasLiveToday: false,
    liveSchedule: '来週火曜19:00〜',
    description:
      '手原産業倉庫は地域密着の物流企業。チームで協力しながら働ける環境です。',
    upcomingSessions: [
      { date: '来週火曜', time: '19:00〜20:00', platform: 'YouTube LIVE' }
    ]
  },
  {
    id: 24,
    name: '永井建設工業',
    industry: '建設',
    tiktokVideoId: '7502353880299212040',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/o4k4rdEIBI3tUj9cAZiBqjIzCAfMzJAIi4wnC8~tplv-tiktokx-origin.image?dr=14575&x-expires=1773846000&x-signature=xvuQEAvKEjLBCkBYMfFQ2gMY%2Ftw%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '建設の現場リアル公開。かっこいい仕事だと思った',
    tags: ['#未経験OK', '#資格取得支援', '#寮完備'],
    publishedDays: 2,
    hasLiveToday: false,
    liveSchedule: '今週金曜18:00〜',
    description:
      '永井建設工業は地域の建設を支える会社。未経験から資格取得まで全力サポート。',
    upcomingSessions: [
      { date: '今週金曜', time: '18:00〜19:00', platform: 'TikTok LIVE' }
    ]
  },
  {
    id: 25,
    name: 'トウテック株式会社',
    industry: '電気工事',
    tiktokVideoId: '7499402378580413703',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/o8oenLUzAtujLGohInODlkkfkcIIJQFoAACTIf~tplv-tiktokx-origin.image?dr=14575&x-expires=1773846000&x-signature=NzxngI6uryxKxNl9VEQu7iQu7zg%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '電気工事の仕事、思ったより面白い。資格も取れる',
    tags: ['#未経験OK', '#資格取得支援', '#手に職つく'],
    publishedDays: 4,
    hasLiveToday: false,
    liveSchedule: '来週水曜20:00〜',
    description:
      'トウテック株式会社は電気工事のプロ集団。未経験から電気工事士を目指せます。',
    upcomingSessions: [
      { date: '来週水曜', time: '20:00〜21:00', platform: 'YouTube LIVE' }
    ]
  },
  {
    id: 26,
    name: 'ギャルすぎる介護士',
    industry: '介護',
    tiktokVideoId: '7318686698425093377',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/dae9aaf99fa74ad8bad60740140f02ed_1704014560~tplv-tiktokx-origin.image?dr=14575&x-expires=1773846000&x-signature=kHiPLtK43fdsHbt8MNwR0d0yTA8%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: 'ギャルでも介護士になれる。個性を活かして働く',
    tags: ['#未経験OK', '#資格取得支援', '#個性活かせる'],
    publishedDays: 3,
    hasLiveToday: false,
    liveSchedule: '今週木曜20:00〜',
    description:
      '個性豊かなスタッフが活躍する介護施設。自分らしく働きながら人の役に立てます。',
    upcomingSessions: [
      { date: '今週木曜', time: '20:00〜21:00', platform: 'TikTok LIVE' }
    ]
  },
  // ── その他（新着・製造・美容） ───────────────
  {
    id: 27,
    name: 'BirTskyマシナリー',
    industry: '製造',
    tiktokVideoId: '7486019185298951431',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/o4k4rdEIBI3tUj9cAZiBqjIzCAfMzJAIi4wnC8~tplv-tiktokx-origin.image?dr=14575&x-expires=1773846000&x-signature=xvuQEAvKEjLBCkBYMfFQ2gMY%2Ftw%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '金属加工の現場公開。精密な仕事にやりがいを感じる',
    tags: ['#未経験OK', '#技術習得', '#ものづくり'],
    publishedDays: 2,
    hasLiveToday: false,
    liveSchedule: '来週月曜19:00〜',
    description:
      'BirTskyマシナリーは精密金属加工のプロ集団。最新設備でスキルアップできます。',
    upcomingSessions: [
      { date: '来週月曜', time: '19:00〜20:00', platform: 'YouTube LIVE' }
    ]
  },
  {
    id: 28,
    name: 'ルラ美容クリニック札幌本院',
    industry: '美容',
    tiktokVideoId: '7478999035093765392',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-i-photomode-sg/943b292fab45486d8a5d855357d63eef~tplv-photomode-image.jpeg?dr=14555&x-expires=1773846000&x-signature=3%2BdK4o5mZ%2FJx8Jbp0E%2Fgb2wDh90%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=9b759fb9&idc=my2&ftpl=1',
    editorNote: '美容クリニックのリアルな日常。清潔感があって素敵',
    tags: ['#未経験OK', '#美容業界', '#スキルアップ'],
    publishedDays: 1,
    hasLiveToday: false,
    liveSchedule: '今週土曜14:00〜',
    description:
      'ルラ美容クリニック札幌本院は最先端の美容医療を提供。スタッフの成長を全力サポート。',
    upcomingSessions: [
      { date: '今週土曜', time: '14:00〜15:00', platform: 'TikTok LIVE' }
    ]
  },
  // ── 新規追加企業 ────────────────────────────
  {
    id: 29,
    name: 'ホットな女子社員ズ',
    industry: 'オフィス',
    tiktokVideoId: '',
    tiktokEmbedUrl: 'https://vt.tiktok.com/ZSuQ1YgLM/',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/6f206a494de7463c8926e3067bff2ebd_1718872336~tplv-tiktokx-origin.image?dr=14575&x-expires=1773907200&x-signature=sJwZebtBo7jgcOIXhIwnE6M4lj4%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '女子社員が活躍中！明るくてエネルギッシュな職場',
    tags: ['#女性活躍', '#職場環境◎', '#未経験OK'],
    publishedDays: 1,
    hasLiveToday: false,
    liveSchedule: '今週土曜20:00〜',
    description:
      '女性が活き活きと働ける職場環境が整ったオフィス。チームワーク抜群で毎日楽しく仕事できます。',
    upcomingSessions: [
      { date: '今週土曜', time: '20:00〜21:00', platform: 'TikTok LIVE' }
    ]
  },
  {
    id: 30,
    name: 'YADUKI/居酒屋 哉月',
    industry: '飲食',
    tiktokVideoId: '',
    tiktokEmbedUrl: 'https://vt.tiktok.com/ZSuxoXeda/',
    videoThumbnail:
      'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-0037/o8fRjSeAazpQISeCDAAmlVJ8hU1AsWBMK5oCJK~tplv-tiktokx-origin.image?dr=14575&x-expires=1773907200&x-signature=TdsTPYg5HlZWk2uNLjhKK6HvCbM%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=sg1',
    editorNote: '個性あふれる居酒屋。楽しみながら成長できる職場',
    tags: ['#未経験OK', '#飲食', '#シフト自由'],
    publishedDays: 1,
    hasLiveToday: false,
    liveSchedule: '今週金曜19:00〜',
    description:
      '居酒屋 哉月はアットホームな雰囲気の個性派居酒屋。スタッフ同士の仲が良く、楽しみながら働けます。',
    upcomingSessions: [
      { date: '今週金曜', time: '19:00〜20:00', platform: 'TikTok LIVE' }
    ]
  }
];